import { render, staticRenderFns } from "./ParentRelatedStudents.vue?vue&type=template&id=6da44c76"
import script from "./ParentRelatedStudents.vue?vue&type=script&lang=js"
export * from "./ParentRelatedStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports